<!--发布需求-->
<template>
  <div class="release-container">
    <headerIndex/>
    <!--面包削-切换导航栏-->
    <div class="release-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
        <el-breadcrumb-item>发布需求</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--正文内容-->
    <div class="release-content">
      <el-form label-position="top" :model="releaseForm" :rules="rules" ref="releaseForm" class="releaseForm">
        <el-form-item label="行业分类" prop="industryClass">
          <el-cascader v-model="releaseForm.industryClass" :options="industryList" style="width: 100%"
                       @change="changeIndustry"
                       placeholder="选择需求分类" clearable/>
        </el-form-item>
        <el-form-item label="需求标题" prop="title">
          <el-input v-model="releaseForm.title" placeholder="请简要概况需求内容，如：商城APP开发" maxlength="20" show-word-limit/>
        </el-form-item>
        <el-form-item label="需求详情" prop="content">
          <el-input v-model="releaseForm.content" type="textarea" placeholder="请详细描述需求内容，便于服务商更好的理解需求。(600字）"
                    :autosize="{ minRows: 7}" maxlength="600" show-word-limit/>
          <el-upload class="upload-demo" ref="upload" :file-list="fileList" drag :on-exceed="handleExceed"
                     :on-success="successUpload" accept=".png,.gif,.jpeg,.jpg"
                     :on-remove="handleRemove" multiple :limit="5"
                     action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg">
            <i class="el-icon-upload"/>
            <div class="el-upload__text">
              <p style="margin-block-end: 0px;margin-block-start: 0px;">将文件拖到此处，或点击上传</p>
              <p style="margin-block-end: 0px;margin-block-start: 0px;font-size: 12px;">最多添加5个文件</p>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="交易金额" prop="money" class="special-form">
          <el-button type="danger" icon="iconfont icon-qiehuan" plain style="margin-right: 20px;"
                     @click="changepriceType">切换{{ releaseForm.priceType == 1 ? '价格区间' : '具体金额' }}
          </el-button>
          <el-input v-model="releaseForm.money" style="width: 80%;" v-if="releaseForm.priceType==1" clearable
                    placeholder="请输入具体价格">
            <i class="price-icon" slot="suffix">元</i>
          </el-input>
          <el-select v-model="releaseForm.money" placeholder="请选择预算区间" style="width: 80%" v-else clearable>
            <el-option v-for="(price, index) in priceList" :key="index" :label="price" :value="price"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投标时间" prop="endTime" class="special-form">
          <el-date-picker v-model="releaseForm.startTime" type="date" placeholder="请选择开始日期"
                          :picker-options="pickerOptions"
                          style="width: 48%;margin-right: 40px;"/>
          <el-date-picker v-model="releaseForm.endTime" type="date" placeholder="请选择截止日期" style="width: 48%;"
                          :picker-options="pickerOptions2"
                          :disabled="releaseForm.startTime!='' ? false : true"/>
        </el-form-item>
        <el-form-item label="投标区域">
          <el-radio v-model="releaseForm.bidAreaType" :label="1" border @change="Changedemand(1)">不限区域</el-radio>
          <el-radio v-model="releaseForm.bidAreaType" :label="2" border @change="Changedemand(2)">设置区域</el-radio>
          <div class="special-div" v-if="releaseForm.bidAreaType==2">
            <el-select placeholder="请选择" v-model="releaseForm.province" style="width: 48%;margin-right: 40px;"
                       @change="changeSelect">
              <el-option v-for="item in provincialCode" :label="item.label" :value="item.value"/>
            </el-select>
            <el-select placeholder="请选择" v-model="releaseForm.city" style="width: 48%;" @change="changeCity">
              <el-option v-for="item in cityCode" :label="item.label" :value="item.value"/>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="手机号码" prop="verification" class="special-info">
          <el-input v-model="releaseForm.verification" placeholder="请输入验证码">
            <el-input v-model="releaseForm.phone" slot="prepend" placeholder="请输入手机号码，便于服务商联系您" clearable
                      style="border-right: 1px solid #EDEDED;"/>
            <el-button slot="append" style="padding: 12px 10px 12px 0px;color: #FE273B;"
                       :disabled="releaseForm.phone!='' ? false : true"
                       @click="getVerification" v-if="flag">获取验证码
            </el-button>
            <el-button slot="append" style="padding: 12px 10px 12px 0px;color: #FE273B;"
                       v-if="!flag" disabled>剩余{{ second }}s
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="微信号码">
          <el-input v-model="releaseForm.wechat" placeholder="请输入微信号，便于服务商联系您"/>
        </el-form-item>
        <el-form-item label="QQ号">
          <el-input v-model="releaseForm.qqNo" placeholder="请输入QQ号，便于服务商联系您"/>
        </el-form-item>
        <el-form-item label="招标工具" class="special-checkbox">
          <el-checkbox v-model="releaseForm.top" true-label="1" false-label="0" border @change="checkTop">
            <div class="checkbox-content">
              <div style="margin-top: 12px"><i class="iconfont icon-top"></i></div>
              <div class="u-flex-col">
                <div class="span1">置顶<span class="span2">￥100</span></div>
                <div class="span3">招标需求置顶五天，提高曝光率和投标度</div>
              </div>
            </div>
          </el-checkbox>
          <el-checkbox v-model="releaseForm.urgent" true-label="1" false-label="0" border @change="checkUrgent">
            <div class="checkbox-content">
              <div style="margin-top: 12px"><i class="iconfont icon-urgent"></i></div>
              <div class="u-flex-col">
                <div class="span1">加急<span class="span2">￥50</span></div>
                <div class="span3">适合紧急任务，提供多方位推广，提高投标度</div>
              </div>
            </div>
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div class="bottom-footer">
        <el-link :underline="false" class="footer-button">应付金额：¥{{
            parseFloat(releaseForm.payMoney).toFixed(2)
          }}
        </el-link>
        <el-button type="danger" @click="releaseDemand">发布需求</el-button>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {
  outsourcingIndustryList,
  priceRangeList,
  saveBiddingRequirements,
  publishBiddingSubmitOrders
} from "@/api/cloudServiceApi";
import provincialCode from '@/static/provincialCode.json'
import {sendsms, verifySms} from '@/api/currencyApi'
import {isMobile, isMoney} from '@/common/tools'

export default {
  name: "releaseDemand",
  components: {headerIndex, Hang, home_footer},
  data() {
    /*校验交易金额*/
    let checkPrice = (rule, value, callback) => {
      if (this.releaseForm.priceType == 1) {
        if (value === '') {
          callback(new Error('交易金额不能为空'));
        } else if (!isMoney(value)) {
          callback(new Error('请输入合法的金额数字，最多两位小数'));
        } else {
          callback();
        }
      } else {
        if (value === '') {
          callback(new Error('请选择预算区间'));
        } else {
          callback();
        }
      }
    };
    /**
     * 校验结束日期
     * 步骤：
     *  1、校验是否选择开始日期
     *  2、结束日期必须大于等于开始日期
     */
    let checkEndTime = (rule, value, callback) => {
      if (this.releaseForm.startTime == '') {
        callback(new Error('请选择开始日期'));
      } else {
        if (value === '') {
          callback(new Error('请选择截止日期'));
        } else {
          callback();
        }
      }
    };
    /**
     * 校验验证码
     * 步骤：
     *  1、检验手机号是否填写正确
     *  2、判断是否发送验证码
     *  3、检验验证码是否填写
     */
    let checkVerification = (rule, value, callback) => {
      if (this.releaseForm.phone == '') {
        callback(new Error('请输入手机号码'));
      } else if (!isMobile(this.releaseForm.phone)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        if (this.flag) {
          callback(new Error('请获取验证码'));
        } else {
          if (value === '') {
            callback(new Error('请输入验证码'));
          } else {
            callback();
          }
        }
      }
    };
    return {
      releaseForm: {
        industryClass: [],
        industryName: [],
        industryId: '',
        title: '',
        content: '',
        money: '',
        time: '',
        area: '',
        phone: '',
        wechat: '',
        qqNo: '',
        biddingTools: '',
        fileList: [],
        priceType: 1,
        startTime: '',
        endTime: '',
        bidAreaType: 1,
        province: '',
        provinceName: '',
        city: '',
        cityName: '',
        verification: '',
        top: 0,
        urgent: 0,
        payMoney: 0,
      },
      provincialCode: provincialCode,
      cityCode: [],
      fileList: [],
      priceList: [],
      second: 300,
      flag: true,
      rules: {
        industryClass: [
          {required: true, message: '请选择需求分类', trigger: 'change'}
        ],
        title: [
          {required: true, message: '请简要概况需求内容', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请详细描述需求内容，便于服务商更好的理解需求', trigger: 'blur'},
          {min: 5, max: 600, message: '长度在 5 到 600 个字符', trigger: 'blur'}
        ],
        money: [
          {required: true, validator: checkPrice, trigger: 'change'}
        ],
        endTime: [
          {required: true, validator: checkEndTime, trigger: 'blur'}
        ],
        verification: [
          {required: true, validator: checkVerification, trigger: 'blur'}
        ],
      },
      industryList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          //如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          //减去一天的时间代表可以选择同一天;
          return time.getTime() < new Date(this.releaseForm.startTime).getTime();
        }
      },
      cid: 0,
    }
  },
  watch: {},
  methods: {
    /*获取行业分类*/
    getOutsourcingIndustryList() {
      outsourcingIndustryList().then(res => {
        if (res.code == 200) {
          for (let list of res.content) {
            let item = {value: list.id, label: list.name, children: []};
            if (list.sonList.length > 0) {
              for (let son of list.sonList) {
                let son_list = {pid: son.pid, value: son.id, label: son.name, children: []}
                if (son.sonList.length > 0) {
                  for (let sons of son.sonList) {
                    let sons_list = {pid: sons.pid, value: sons.id, label: sons.name}
                    son_list.children.push(sons_list);
                  }
                }
                item.children.push(son_list);
              }
            }
            this.industryList.push(item);
          }
        }
      })
    },
    /*限制图片上传上限 超过提示*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*图片上传成功后处理*/
    successUpload(response, file, fileList) {
      this.releaseForm.fileList = [];
      for (let list of fileList) {
        this.releaseForm.fileList.push({name: list.name, url: list.response.imgPath});
      }
    },
    /*删除图片*/
    handleRemove(file, fileList) {
      for (let i in this.releaseForm.fileList) {
        if (this.releaseForm.fileList[i].url == file.response.imgPath) {
          this.releaseForm.fileList.splice(i, 1)
          this.$message.success('删除成功！');
        }
      }
    },
    /*获取价格区间*/
    getPriceRangeList() {
      priceRangeList().then((res) => {
        if (res.code == 200) {
          this.priceList = res.content;
        }
      });
    },
    /*切换价格区间*/
    changepriceType() {
      if (this.releaseForm.priceType == 1)
        this.releaseForm.priceType = 2;
      else
        this.releaseForm.priceType = 1;
    },
    /*监听省级城市切换*/
    changeSelect(event, item) {
      this.releaseForm.city = '';
      for (let province of this.provincialCode) {
        if (event == province.value) {
          this.cityCode = province.children;
          this.releaseForm.provinceName = province.label;
        }
      }
    },
    /*监听投标区域变更*/
    Changedemand(status) {
      if (status == 1) {
        this.releaseForm.city = '';
        this.releaseForm.cityName = '';
        this.releaseForm.province = '';
        this.releaseForm.provinceName = '';
        this.cityCode = [];
      }
    },
    /*监听切换二级城市*/
    changeCity(value) {
      for (let province of this.provincialCode) {
        if (this.releaseForm.province == province.value) {
          for (let city of province.children) {
            if (value == city.value) {
              this.releaseForm.city = city.value;
              this.releaseForm.cityName = city.label;
            }
          }
        }
      }
    },
    /*获取手机验证码*/
    getVerification() {
      let that = this;
      sendsms({
        mobile: that.releaseForm.phone,
        name: "发布需求",
        uuid: "帮企网",
        uid: that.cid != 0 && that.cid != undefined ? that.cid : 0,
      }).then(res => {
        that.flag = false;
        let interval = window.setInterval(function () {
          that.setStorage(that.second);
          if (that.second-- <= 0) {
            that.second = 300;
            that.flag = true;
            window.clearInterval(interval);
          }
        }, 1000);
      })
    },
    /*设置缓存信息*/
    setStorage(parm) {
      localStorage.setItem("dalay", parm);
      localStorage.setItem("_time", new Date().getTime());
    },
    /*获取缓存信息*/
    getStorage() {
      let localDelay = {};
      localDelay.delay = localStorage.getItem("dalay");
      localDelay.sec = localStorage.getItem("_time");
      return localDelay;
    },
    /*选择置顶，产生额外费用*/
    checkTop() {
      if (this.releaseForm.top == 1) {
        this.releaseForm.payMoney += 100;
      } else {
        this.releaseForm.payMoney -= 100;
      }
    },
    /*选择加急，产生额外费用*/
    checkUrgent() {
      if (this.releaseForm.urgent == 1) {
        this.releaseForm.payMoney += 50;
      } else {
        this.releaseForm.payMoney -= 50;
      }
    },
    /*发布需求*/
    releaseDemand() {
      let that = this;
      that.$refs.releaseForm.validate((valid) => {
        if (valid) {
          /*短信验证发布需求，code==200则表示可发布需求 验证失败则无法发布*/
          verifySms({
            smscode: that.releaseForm.verification,
            uid: that.cid != 0 && that.cid != undefined ? that.cid : 0,
            uuid: that.releaseForm.phone,
          }).then(res => {
            if (res.code == 200) {
              //选择了增值服务
              if (that.releaseForm.payMoney > 0) {
                that.dialogVisible = true;
              } else {//没有选择增值服务
                that.saveRelease();
              }
            }else{
              this.$message.error('手机号验证失败。')
            }
          })
        } else {
          return false;
        }
      });
    },
    /*提交发布需求*/
    saveRelease() {
      let that = this;
      saveBiddingRequirements({
        appendix: that.releaseForm.fileList,
        bidAreaType: that.releaseForm.bidAreaType, /*投标区域方式（1：不限区域，2：设置区域）*/
        city: that.releaseForm.city,
        cityName: that.releaseForm.cityName,
        code: that.releaseForm.verification,
        content: that.releaseForm.content,
        endTime: new Date(that.releaseForm.endTime).format("yyyy-MM-dd"),
        industryId: that.releaseForm.industryId,
        industryName: that.releaseForm.industryName,
        mobile: that.releaseForm.phone,
        money: that.releaseForm.money,
        province: that.releaseForm.province,
        provinceName: that.releaseForm.provinceName,
        qq: that.releaseForm.qqNo,
        startTime: new Date(that.releaseForm.startTime).format("yyyy-MM-dd"),
        title: that.releaseForm.title,
        top: that.releaseForm.top,
        uid: that.cid != 0 && that.cid != undefined ? that.cid : 0,
        urgent: that.releaseForm.urgent,
        wx: that.releaseForm.wechat,
      }).then(res => {
        if (res.code == 200) {
          that.$alert('需求提交成功，请耐心等待，我们正在快速审核中', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.$router.back(-1);
            }
          });
        }
      })
    },
    /*监听行业修改*/
    changeIndustry(val) {
      for (let industry of this.industryList) {
        /*当一级行业id相等取出其之下的子行业*/
        if (val[0] == industry.value) {
          /*当二级行业id相等取出其之下的子行业*/
          for (let son of industry.children) {
            if (val[1] == son.value) {
              /*当三级行业id相等赋值中文名称*/
              for (let sonList of son.children) {
                if (val[2] == sonList.value) {
                  this.releaseForm.industryName = sonList.label;
                  this.releaseForm.industryId = sonList.value;
                }
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getOutsourcingIndustryList();
    this.getPriceRangeList();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.release-container >>> .release-content .el-form--label-top .el-form-item__label {
  padding: 0 0 0px;
  font-weight: 100;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
}

.release-container >>> .release-content .releaseForm .el-upload-dragger {
  background-color: #F7F7F7;
  border: 1px solid #EDEDED;
  border-radius: 0px;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}

.release-container >>> .release-content .releaseForm .el-upload {
  width: 100%;
}

.release-container >>> .release-content .releaseForm .el-upload-dragger .el-icon-upload {
  font-size: 26px;
  color: #ABABAB;
  margin: 0px 10px 0px 0px;
  line-height: normal;
  padding-bottom: 26px;
}

.release-container >>> .release-content .releaseForm .el-upload-dragger .el-upload__text {
  color: #ABABAB;
  line-height: 25px;
}

.release-container >>> .release-content .releaseForm .el-upload-list__item {
  font-size: 14px;
  color: #606266;
  width: fit-content;
}

.release-container >>> .release-content .releaseForm input::-webkit-input-placeholder,
.release-container >>> .release-content .releaseForm textarea::-webkit-input-placeholder {
  font-size: 14px;
  color: #ABABAB;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}

.release-container >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.release-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.release-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.release-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.release-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.release-container >>> .release-content .releaseForm .el-textarea__inner {
  border-radius: 4px 4px 0px 0px;
}

.release-container >>> .release-content .releaseForm .special-form .el-form-item__content {
  display: flex;
  justify-content: space-between;
}

.release-container >>> .release-content .releaseForm .el-upload-list__item .el-icon-close {
  opacity: 100%;
  color: #ffffff;
  background: #9A9A9A;
  border-radius: 50%;
  padding: 3px;
}

.release-container >>> .release-content .releaseForm .special-form .el-button {
  padding: 11px 20px;
  font-size: 14px;
}

.release-container >>> .release-content .releaseForm .el-radio.is-bordered.is-checked {
  border-color: #FFF2F3;
  background: #FFF2F3;
}

.release-container >>> .release-content .releaseForm .el-radio__input.is-checked + .el-radio__label {
  color: #FE273B;
}

.release-container >>> .release-content .releaseForm .el-radio__input.is-checked .el-radio__inner {
  border-color: #FE273B;
  background: #FE273B;
}

.release-container >>> .release-content .releaseForm .el-radio.is-bordered {
  padding: 15px 20px 15px 20px;
  border: 1px solid #F7F7F7;
  background: #F7F7F7;
  height: auto;
}

.release-container >>> .release-content .releaseForm .el-radio {
  color: #333333;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
  margin-right: 40px;
}

.release-container >>> .release-content .releaseForm .special-info .el-input-group__append,
.release-container >>> .release-content .releaseForm .special-info .el-input-group__prepend {
  background-color: #ffffff;
  color: #333333;
  border: none;
  border-radius: 0px;
  padding: 0 0px;
  width: max-content;
}

.release-container >>> .release-content .releaseForm .special-info .el-input-group {
  border: 1px solid #EDEDED;
}

.release-container >>> .release-content .releaseForm .special-info .el-input__inner {
  border: none;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}

.release-container >>> .release-content .releaseForm .special-checkbox .el-checkbox__inner {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.release-container >>> .release-content .releaseForm .special-checkbox .el-checkbox__input.is-checked .el-checkbox__inner,
.release-container >>> .release-content .releaseForm .special-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FE273B;
  border-color: #FE273B;
}

.release-container >>> .release-content .releaseForm .special-checkbox .el-checkbox__inner::after {
  border-width: 2px;
  height: 10px;
  left: 6px;
  top: 2px;
  width: 4px;
}

.release-container >>> .release-content .releaseForm .special-checkbox .el-checkbox.is-bordered {
  padding: 0px 15px 0px 20px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 100px;
  background: #F4F8FA;
  display: flex;
  width: 48%;
  align-items: center;
}

.release-container >>> .release-content .releaseForm .special-checkbox .el-form-item__content {
  display: flex;
}

.release-container >>> .release-content .bottom-footer .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}

.release-container >>> .release-content .bottom-footer .el-button--danger:hover {
  color: #FE273B;
  background: #fef0f0;
  border-color: #FE273B;
}

.release-container >>> .release-content .releaseForm .special-form .el-button--danger.is-plain {
  color: #FE273B;
  background: #fef0f0;
  border-color: #fef0f0;
}

.release-container >>> .release-content .releaseForm .special-form .el-button--danger.is-plain:hover {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}
</style>
<style scoped lang="scss">
.release-container {
  background: #F5F5F5;

  .release-breadcrumb {
    padding: 20px 18%;
  }

  .release-content {
    margin: 0px 18% 30px;
    background: #ffffff;

    .releaseForm {
      padding: 30px 25% 0px 60px;

      .price-icon {
        font-style: normal;
        font-size: 14px;
        color: #ABABAB;
        padding-right: 20px;
      }

      .special-div {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
      }

      .special-checkbox {
        .checkbox-content {
          display: flex;
          align-items: center;

          .icon-urgent {
            font-size: 32px;
            margin: 0px 15px 0px 0px;
            color: #9A9A9A;
          }

          .icon-top {
            font-size: 32px;
            margin: 0px 15px 0px 0px;
            color: #9A9A9A;
          }

          .span2 {
            color: #FE273B;
            font-size: 16px;
            font-family: 'SourceHanSansCN';
          }

          .span1 {
            color: #333333;
            font-family: 'SourceHanSansCN';
            font-size: 16px;
          }

          .span3 {
            color: #ABABAB;
            font-size: 12px;
            padding-top: 5px;
          }
        }
      }
    }

    .bottom-footer {
      background: #ffffff;
      border-top: 1px solid #EDEDED;
      padding: 20px 60px;
      margin-top: 50px;
      display: flex;

      .footer-button {
        color: #333333;
        padding-right: 50px;
      }
    }
  }
}
</style>